module.exports = __webpack_public_path__ + "img/logo-dark.5d43a612.png";